import { render, staticRenderFns } from "./SignDocumentPage.vue?vue&type=template&id=64d3cb59&scoped=true"
import script from "./SignDocumentPage.vue?vue&type=script&lang=js"
export * from "./SignDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3cb59",
  null
  
)

export default component.exports